import { Upload } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

/**
 * Feature 117: Referrals tab header action that opens the bulk-upload flow
 * (moved here from the Providers tab). The caller gates it on
 * MANAGE_USERS_AND_RESOURCES and swaps the tab content for BulkUploadSurface.
 */
export const BulkUploadReferralsButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    type="button"
    variant="outline"
    onClick={onClick}
    className="border-[#15543e] text-[#15543e] hover:bg-[#15543e]/5 hover:text-[#15543e]"
  >
    <Upload className="mr-2 h-4 w-4" aria-hidden />
    Bulk upload referrals
  </Button>
);
